import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, LinkedInput } from 'components/basic'

class Account extends Component {
  constructor (props) {
    super(props)
    this.state = {...props.user}
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.user.name === nextProps.user.name) return
    this.setState({...nextProps.user})
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Installation' subtitle={this.props.user.name} icon='fa-gear' />
        <div className='row'>
          <StaticBox title={this.props.user.name} icon='user'>
            <div className='row'>
              <div className='col-md-4'>
                <label>Username</label>
                <LinkedInput context={this} editable={false} path='name' />
              </div>
              <div className='col-md-4'>
                <label>Company</label>
                <LinkedInput context={this} editable={false} path='company' />
              </div>
            </div>
          </StaticBox>
      </div>
    </div>

    )
  }
}
//eslint-disable-next-line
Account = connect(state => state.siteReducer)(Account)
export default Account



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/views/installation/account.js